/* Package JSON Import will be here */
import React, { Component } from 'react';
/* Package JSON Import will be here */

/* Project Import will be here */
import splashScreenContainer from './splashScreen.Container';
/* Project Import will be here */

export default class SplashScreen extends Component {

    render() {
        const WrappedSplashScreen = splashScreenContainer;

        return (
            <WrappedSplashScreen />
        );
    }
}

SplashScreen.displayName = 'SplashScreen';